// TODO add desc sorting and update logic for requests
export enum CatalogSearchASC {
  start_date = 'По дате проведения',
  end_date = 'По дате проведения с новых',
  created = 'По дате создания',
  subscriptions = 'По популярности',
  viewings = 'По просмотрам',
}
